import {motion, Variants} from 'framer-motion';
import {FC} from "react";
import styles from './AnimatedRoute.module.scss';
import * as React from "react";

const variantRight = {
    initial: {opacity: 0, x: 100},
    in: {opacity: 1, x: 0},
};
const variantBottom = {
    initial: {opacity: 0, y: 100},
    in: {opacity: 1, y: 0},
};
const variantTop = {
    initial: {opacity: 0, y: -100},
    in: {opacity: 1, y: 0},
};

const pageTransition = {
    duration: 0.4,
};
export enum AnimateVariant {
    top,
    bottom

}
type AnimatedRouteProps = {
    variants?: AnimateVariant,
}
export const AnimatedRoute: FC<AnimatedRouteProps> = ({children, variants}) => {
    const fullCls = (variants === AnimateVariant.bottom || variants === AnimateVariant.top) ? styles.full : ''
    let variant:Variants;
    switch (variants){
        case AnimateVariant.top:
            variant = variantTop
            break
        case AnimateVariant.bottom:
            variant = variantBottom
            break
        default:
            variant = variantRight
            break
    }
    return (
        <motion.div
            className={`${styles.root} ${fullCls}`}
            initial="initial"
            animate="in"
            variants={variant}
            transition={pageTransition}
        >
            {children}
        </motion.div>
    );
};
